<template>
  <li class="menu-title ms-2 p my-2 fw-bold text-uppercase">{{ title }}</li>
</template>

<script>
export default {
  name: "MenuLi",
  props: {
    title: {
      type: String,
      default: "Category Management",
    },
  },
}
</script>

<style scoped>
.menu-title{
  font-size: .9rem;
}
</style>